export default __webpack_public_path__ + "static/media/icon-upload-new.84c342bc.svg";